export default "__VITE_ASSET__lGt1156i__"